import _ from 'underscore/modules/index-default';

import 'extensions/underscore/generate';
import 'extensions/underscore/sameAs';
import 'extensions/underscore/takeWhile';

export default _;